export enum CCOType {
    None,
    Save,
    Delete
}
